module.exports = __webpack_public_path__ + "img/fake-user-0.a3c4a14f.png";